export default __webpack_public_path__ + "static/media/ai-robot.bbd6073b.png";